import {DisclaimerType} from "../../definitions/types";

export class DisclaimerModel {
    private readonly _disclaimer: DisclaimerType;

    /**
     * @constructor
     * @param disclaimer - The disclaimer to be modeled.
     * @description Creates a new instance of the DisclaimerModel class.
     */
    constructor(public readonly disclaimer: DisclaimerType) {
        this._disclaimer = disclaimer;
    }

    /**
     * @method id
     * @description Returns the id of the disclaimer.
     * @returns {number}
     */
    public get id(): number {
        return this._disclaimer.id;
    }

    /**
     * @method productId
     * @description Returns the product id of the disclaimer.
     * @returns {number}
     */
    public get productId(): number {
        return this._disclaimer.productId;
    }

    /**
     * @method sku
     * @description Returns the sku of the disclaimer.
     * @returns {string}
     */
    public get sku(): string {
        return this._disclaimer.sku;
    }

    /**
     * @method materialCode
     * @description Returns the material code of the disclaimer.
     * @returns {string | undefined}
     */
    public get materialCode(): string | undefined {
        return this._disclaimer.materialCode;
    }

    /**
     * @method materialDescription
     * @description Returns the material description of the disclaimer.
     * @returns {string | undefined}
     */
    public get materialDescription(): string | undefined {
        return this._disclaimer.materialDescription;
    }

    /**
     * @method chemical
     * @description Returns the chemical name of the disclaimer.
     * @returns {string | undefined}
     */
    public get chemical(): string | undefined {
        return this._disclaimer.chemical;
    }

    /**
     * @method toxicity
     * @description Returns the toxicity type of the disclaimer.
     * @returns {string | undefined}
     */
    public get toxicity(): string | undefined {
        return this._disclaimer.toxicityType;
    }
}